module.exports = __webpack_public_path__ + "img/boca.b276bd53.png";